import { gql } from "@apollo/client";
import FormDialog from "controls/FormDialog";
import { useActionFragment } from "hooks/useAction";
import useData from "hooks/useData";
import { Cog } from "mdi-material-ui";
import React from "react";
import ScorekeeperConfigsForm, { ScorekeeperConfigsFormFragment } from "readmin_pages/scorekeeper_configs/Form";

CompetitionsScorekeeperConfigDialog.useButtonProps = () => {
  return {
    icon: <Cog />,
    content: "Edit Scorekeeper Settings",
  };
};

export default function CompetitionsScorekeeperConfigDialog({ competitionIds, onSubmit, onClose }) {
  const [data, dataMeta] = useData(
    gql`
      query CompetitionsScorekeeperConfigDialog($competitionIds: [ID!]!) {
        competitions(ids: $competitionIds) {
          id
          sport
          scorekeeperConfig {
            ...ScorekeeperConfigsFormFragment
          }
        }
      }
      ${ScorekeeperConfigsFormFragment}
    `,
    { competitionIds },
  );
  const competitionsUpdateScorekeeperConfig = useActionFragment("competitionsUpdateScorekeeperConfig");

  return (
    <FormDialog
      loading={dataMeta.loading}
      header="Edit Scorekeeper Settings"
      onClose={onClose}
      onSubmit={async (formData) => {
        await competitionsUpdateScorekeeperConfig({
          input: {
            competitionIds,
            scorekeeperConfigInput: {
              ...formData,
            },
          },
        });
        await onSubmit?.();
      }}
    >
      <ScorekeeperConfigsForm scorekeeperConfigs={data?.competitions.map((l) => l.scorekeeperConfig)} />
    </FormDialog>
  );
}
